// load styles for checkboxes in reader mode
import {customCheckboxStyles} from "@/components/tinyMce/plugins/customCheckbox/styles/custom-checkbox-styles";

const loadCheckboxViewModeAssets = (doc: Document = document) => {
  const checkboxViewModeStylesId = 'custom-checkbox-viewmode-styles';
  if (!doc.getElementById(checkboxViewModeStylesId)) {
    const style = doc.createElement('style');
    style.id = checkboxViewModeStylesId;
    style.textContent = ` ${customCheckboxStyles}
                            .tmce-plugin-custom-checkbox {
                              pointer-events: none;
                            }
                         `;
    doc.head.appendChild(style);
  }
};

export default {
  loadCheckboxViewModeAssets,
}
